import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { finalize } from 'rxjs';
import { AdminDashboardService } from '../admin-dashboard.service';
import { AiSummaryCardComponent } from '@/shared/components/ai-summary-card/ai-summary-card.component';
import { AsyncState } from '@/shared/models/async-state.model';
import { AiSummaryDto } from '@/shared/models/ai-summary.model';

@Component({
    standalone: true,
    selector: 'app-a-ai-summary-widget',
    imports: [CommonModule, AiSummaryCardComponent],
    template: `<app-ai-summary-card [state]="summaryState()" />`
})
export class AAiSummaryWidget implements OnInit {
    public readonly summaryState = signal<AsyncState<AiSummaryDto>>({ data: null, loading: false, error: null });

    private readonly _adminDashboardService = inject(AdminDashboardService);

    public ngOnInit(): void {
        this.loadSummary();
    }

    private loadSummary(): void {
        this.summaryState.update((state) => ({ ...state, loading: true, error: null }));
        this._adminDashboardService
            .getAdminAiSummary()
            .pipe(finalize(() => this.summaryState.update((state) => ({ ...state, loading: false }))))
            .subscribe({
                next: (data) => this.summaryState.set({ data, loading: false, error: null }),
                error: (err: unknown) => this.summaryState.set({ data: null, loading: false, error: err })
            });
    }
}
